import(/* webpackMode: "eager" */ "/Users/kohjx/actions-runner/_work/IDEight-v3/IDEight-v3/apps/web/app/error.tsx");
